import { props } from 'cerebral'
import { debounce, set } from 'cerebral/factories'
import { compose, path, pluck, unnest } from 'ramda'
import { loadProfilesSequence } from '../profiles/factories'
import { saveEntities } from '../factories'
import { showFeedback } from '../feedback/factories'
import * as actions from './actions'
import { sequences as route } from '../route'

const loadProfiles = loadProfilesSequence(compose(pluck('profile'), unnest, pluck('waitlist'), path(['props', 'entities', 'eventInstances'])), 'profileIds')

export const find = [
  //
  actions.useTimeRange,
  actions.find,
  saveEntities(),
  loadProfiles,
]

export const findForCalendar = [
  //
  find,
  actions.mapCalendarFields,
]

export const findForList = [
  //
  set(props`useRouteParams`, true),
  set(props`query.attendanceDisabled`, { $ne: true }), // Always hide events with attendance disabled from list.
  actions.useTimeRange,
  actions.find,
  actions.setList,
  saveEntities(),
]

export const get = [
  //
  actions.get,
  saveEntities(),
  loadProfiles,
]

export const save = [
  //
  actions.save,
  actions.clearList,
  saveEntities(),
  showFeedback({ title: 'Event instance saved', type: 'success' }),
]

export const remove = [
  //
  actions.remove,
  showFeedback({ title: 'Event instance cleared', type: 'success' }),
  find,
]

export const dashboardRefresh = [
  //
  debounce(50),
  {
    continue: actions.dashboardRefresh,
    discard: [],
  },
]

export const dashboardSetTimeRange = [
  //
  actions.dashboardSetTimeRange,
  dashboardRefresh,
]

export const dashboardSetCalendar = [
  //
  actions.dashboardSetCalendar,
  dashboardRefresh,
]

export const dashboardSetLedBy = [
  //
  actions.dashboardSetLedBy,
  dashboardRefresh,
]

export const dashboardDataReset = [
  //
  actions.dashboardDataReset,
]

export const getReport = [
  //
  actions.getReport,
]

export const removeFromWaitlist = [
  //
  actions.removeFromWaitlist,
  saveEntities(),
  showFeedback({ title: 'Waitlist updated', type: 'success' }),
]

export const moveToRsvp = [
  //
  actions.moveToRsvp,
  saveEntities(),
  showFeedback({ title: 'Waitlist updated', type: 'success' }),
]

export const setAttendance7d = [
  //
  actions.setAttendance7d,
  set(props`params`, { filter: 'hasNoAttendance' }),
  route.toEventInstances,
]
